/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetVersion200Response,
} from '../models';
import {
    GetVersion200ResponseFromJSON,
    GetVersion200ResponseToJSON,
} from '../models';

/**
 * 
 */
export class VersionApi extends runtime.BaseAPI {

    /**
     * Get current git version
     * Get current git version
     */
    async getVersionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetVersion200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/version`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetVersion200ResponseFromJSON(jsonValue));
    }

    /**
     * Get current git version
     * Get current git version
     */
    async getVersion(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetVersion200Response> {
        const response = await this.getVersionRaw(initOverrides);
        return await response.value();
    }

}
